export default "__VITE_ASSET__m2MzBF9j__ 584w";